import { api } from '../../../utils/api';
import { toast } from '../../ui/simple-toaster';

/**
 * Hook for journey/distance-check actions: geocode, radius check, address autocomplete.
 */
export function useJourneyActions({
  driverInfo,
  journeyDestination, setJourneyDestination,
  journeyLoading, setJourneyLoading,
  setJourneyResult,
  setAddressSuggestions, setShowSuggestions,
  setShowJourneyModal, setShowRadiusWarning,
}) {
  const checkJourneyRadius = async () => {
    if (!journeyDestination.trim() || !driverInfo) return;
    setJourneyLoading(true);
    setJourneyResult(null);

    try {
      const geocodeRes = await api(`/journey/geocode?address=${encodeURIComponent(journeyDestination)}`);
      if (!geocodeRes.coordinates) {
        toast.error('Could not find that address. Please try a more specific address.');
        setJourneyLoading(false);
        return;
      }

      const radiusRes = await api('/journey/radius-check', {
        method: 'POST',
        body: JSON.stringify({ driver_id: driverInfo.driver_id, destination: geocodeRes.coordinates })
      });

      setJourneyResult(radiusRes);

      if (!radiusRes.within_radius) {
        setShowJourneyModal(false);
        setShowRadiusWarning(true);
      } else {
        setShowJourneyModal(false);
        toast.success(`Destination is ${radiusRes.distance_km}km from base (within 100km radius)`);
      }
    } catch (err) {
      toast.error('Error checking journey: ' + err.message);
    } finally {
      setJourneyLoading(false);
    }
  };

  const searchAddresses = async (query) => {
    if (query.length < 3) {
      setAddressSuggestions([]);
      setShowSuggestions(false);
      return;
    }
    try {
      const response = await api(`/journey/autocomplete?query=${encodeURIComponent(query)}`);
      if (response.suggestions) {
        setAddressSuggestions(response.suggestions);
        setShowSuggestions(true);
      }
    } catch (err) {
      console.error('Address search error:', err);
    }
  };

  const handleAddressChange = (e) => {
    const value = e.target.value;
    setJourneyDestination(value);
    searchAddresses(value);
  };

  const selectAddress = (address) => {
    setJourneyDestination(address);
    setShowSuggestions(false);
    setAddressSuggestions([]);
  };

  return { checkJourneyRadius, handleAddressChange, selectAddress };
}
